import React, { useState, useEffect } from 'react';
import type { Theme } from '@material-ui/core';
import { LinearProgress } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

type TransferProgressBarProps = {
    isTransferring: boolean;
    durationSeconds?: number;
};

const styles = (theme: Theme) => ({
    progressBar: {
        height: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
    },
});

export const TransferProgressBar: React.FC<TransferProgressBarProps> = ({
    isTransferring,
    durationSeconds = 180,
}) => {
    const classes = useKlpStyles({}, styles);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (isTransferring) {
            const duration = durationSeconds * 1000; // Convert to milliseconds
            const interval = 1000; // Update every 1000ms
            const increment = (interval / duration) * 100;

            const timer = setInterval(() => {
                setProgress((oldProgress) => {
                    const newProgress = oldProgress + increment;
                    if (newProgress >= 100) {
                        clearInterval(timer);
                        return 100;
                    }
                    return newProgress;
                });
            }, interval);

            return () => {
                clearInterval(timer);
            };
        }
        setProgress(0);
        return undefined;
    }, [isTransferring, durationSeconds]);

    if (!isTransferring) {
        return null;
    }

    return (
        <LinearProgress
            variant="determinate"
            value={progress}
            className={classes.progressBar}
        />
    );
};
